// extracted by mini-css-extract-plugin
export default {"wrapper":"LogModal_wrapper__Lb5Wj","title":"LogModal_title__mOnat","logs":"LogModal_logs__W8IAZ","log":"LogModal_log__SEiDV"};